import { Pipe, PipeTransform } from '@angular/core';
import {
  EXPENSE_STATUS_BADGE,
  ExpenseStatusBadge,
} from '../constants/expense-status-badge.map';
import { ExpenseStatus, isExpenseStatus } from '../enums/expense-status.enum';

@Pipe({ name: 'expenseStatusBadge' })
export class ExpenseStatusBadgePipe implements PipeTransform {
  /** Devuelve `null` para los gastos históricos, que no tienen estado. */
  transform(status: ExpenseStatus | null | undefined): ExpenseStatusBadge | null {
    return isExpenseStatus(status) ? EXPENSE_STATUS_BADGE[status] : null;
  }
}
